import React from "react";
import { Table, Button, Tooltip } from "antd";
import { SettingOutlined } from "@ant-design/icons";

export default function BoilerTable({ data, onEdit }) {
  const columns = [
    {
      title: "Boiler Title",
      dataIndex: "title",
      key: "title",
      align: "center",
    },
    {
      title: "Boiler Make",
      dataIndex: "boiler_make",
      key: "boiler_make",
      align: "center",
    },
    {
      title: "Boiler Model",
      dataIndex: "boiler_model",
      key: "boiler_model",
      align: "center",
    },
    {
      title: "Boiler Capacity",
      dataIndex: "boiler_capacity",
      key: "boiler_capacity",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Tooltip title="Configure parameters">
          <Button
            type="primary"
            size="small"
            onClick={() => onEdit?.(record)}
            style={{ marginRight: "5px" }}
            icon={<SettingOutlined />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      bordered
      pagination={{ pageSize: 10 }}
      rowKey="key"
      className="custom-table"
    />
  );
}
